<template>
    <div class="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div class="absolute left-2 top-[30%] sm:top-[35%] z-5">
            <a @click="scrollPrev"
                class="pointer-events-auto flex w-10 h-10 mr-1 justify-center items-center rounded-full border border-gray-200 dark:border-neutral-700 bg-white/50 dark:bg-neutral-800/50 text-black dark:text-white hover:border-gray-300 hover:scale-110 active:scale-90 backdrop-blur-sm shadow-lg transition"
                title="Previous Page">
                <span class="sr-only">Previous Page</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="block w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
            </a>
        </div>
        <div class="absolute right-2 top-[30%] sm:top-[35%] z-5">
            <a @click="scrollNext"
                class="pointer-events-auto flex w-10 h-10 ml-1 justify-center items-center rounded-full border border-gray-200 dark:border-neutral-700 bg-white/50 dark:bg-neutral-800/50 text-black dark:text-white hover:border-gray-300 hover:scale-110 active:scale-90 backdrop-blur-sm shadow-lg transition"
                title="Next Page">
                <span class="sr-only">Next Page</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="block w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ScrollButtons',
    data() {
        return {
            scrollContainer: null,
            scrollAmount: 0
        };
    },
    mounted() {
        // Find the closest parent scroll container
        this.scrollContainer = this.$el.parentElement.querySelector('.scrollContainer');

        if (this.scrollContainer) {
            this.scrollAmount = this.scrollContainer.offsetWidth * 0.8;
        } else {
            console.warn('Scroll container not found.');
        }
    },
    methods: {
        scrollNext() {
            if (this.scrollContainer) {
                const amount = this.getScrollAmount();
                this.scrollContainer.scrollBy({
                    left: amount,
                    behavior: 'smooth'
                });
            }
        },
        scrollPrev() {
            if (this.scrollContainer) {
                const amount = this.getScrollAmount();
                this.scrollContainer.scrollBy({
                    left: -amount,
                    behavior: 'smooth'
                });
            }
        },
        getScrollAmount() {
            const isSmallScreen = window.innerWidth < 640; // Tailwind "sm" breakpoint
            if (isSmallScreen) {
                const firstItem = this.scrollContainer.querySelector(':scope > *');
                return firstItem?.offsetWidth || 200; // fallback width
            }
            return this.scrollAmount; // use predefined for larger screens
        }
    }
};
</script>
